module.exports = __webpack_public_path__ + "static/email1-0cd4a097022caab4f288e7050c0b8ef2.gif";